import { injectable } from 'tsyringe';
import { PengajuanJenisPelatihanApiRepository } from '../../app/repository/api/PengajuanJenisPelatihanApiRepository';
import { PengajuanJenisPelatihan } from '../../entities/PengajuanJenisPelatihan';

@injectable()
export class PengajuanJenisPelatihanPresenter {
  private repository: PengajuanJenisPelatihanApiRepository;

  constructor(repository: PengajuanJenisPelatihanApiRepository) {
    this.repository = repository;
  }

  public getAllPengajuanJenisPelatihan(
    page: number,
    rows: number,
    keyword: string,
    sub_menu_jenis_pelatihan_id: string,
    status_pengajuan: string
  ): Promise<PengajuanJenisPelatihan[]> {
    return this.repository.getAllPengajuanJenisPelatihan(
      page,
      rows,
      keyword,
      sub_menu_jenis_pelatihan_id,
      status_pengajuan
    );
  }

  public getDetailPengajuanJenisPelatihan(
    id: number
  ): Promise<PengajuanJenisPelatihan> {
    return this.repository.getDetailPengajuanJenisPelatihan(id);
  }

  public storePengajuanJenisPelatihan(
    sub_menu_jenis_pelatihan_id: number,
    nama_pelatihan: string,
    waktu_mulai: string,
    waktu_selesai: string,
    kompetensi: string,
    jp: string,
    keterangan: string
  ): Promise<any> {
    return this.repository.storePengajuanJenisPelatihan(
      sub_menu_jenis_pelatihan_id,
      nama_pelatihan,
      waktu_mulai,
      waktu_selesai,
      kompetensi,
      jp,
      keterangan
    );
  }

  public updatePengajuanJenisPelatihan(
    id: number,
    sub_menu_jenis_pelatihan_id: number,
    nama_pelatihan: string,
    waktu_mulai: string,
    waktu_selesai: string,
    kompetensi: string,
    jp: string,
    keterangan: string,
    status_pengajuan: string,
    kode: string,
    alasan: string
  ): Promise<any> {
    return this.repository.updatePengajuanJenisPelatihan(
      id,
      sub_menu_jenis_pelatihan_id,
      nama_pelatihan,
      waktu_mulai,
      waktu_selesai,
      kompetensi,
      jp,
      keterangan,
      status_pengajuan,
      kode,
      alasan
    );
  }

  public deletePengajuanJenisPelatihan(id: number): Promise<any> {
    return this.repository.deletePengajuanJenisPelatihan(id);
  }
}
